module.exports = __webpack_public_path__ + "static/media/profilePlaceholder-5.891a2454.png";